// import { House, UsersThree, Chalkboard, 
//     BookBookmark, MegaphoneSimple, ShieldCheckered, Calculator, User, CrownSimple, 
//     HandsClapping, Trophy, Target, ChartPie, Books, CalendarPlus,
//     Coins, ChartLineUp, PlusCircle, CirclesThreePlus,
//     RocketLaunch, GearSix, Power, Bag, UserCircle } from 'phosphor-react';
import { House, UsersThree, Chalkboard, User, CrownSimple,Calculator, Coins, PlusCircle,
HandsClapping, Trophy, RocketLaunch, GearSix, Power, Bag, UserCircle,
Desktop, ShieldCheckered, ChartLineUp, Storefront, TreeEvergreen, UserSwitch   } from 'phosphor-react';

export const navigation=[
    {
        id:1,
        name:"Home",
        path:"/dashboard",
        icon:<House className='page_navigation_content_icon' weight='fill'/>
    },
    {
        id:2,
        name:"Team",
        path:"team/teacher",
        Id:"step-1",
        icon:<UsersThree className='page_navigation_content_icon' weight='fill'/>,
        subNavigation:[
            {
                id:2.1,
                title:"Teachers",
                path:"team/teacher",
                logo:<User className='page_sub_navigation_icon' weight="fill"/>,
            },
            {
                id:2.2,
                title:"Admins",
                path:"team/admin",
                logo:<CrownSimple className='page_sub_navigation_icon' weight="fill"/>,
            },
            {
                id:2.3,
                title:"Helping Staffs",
                path:"team/helping-staff",
                logo:<HandsClapping className='page_sub_navigation_icon' weight="fill"/>,
            },
            {
                id:2.4,
                title:"Leader Board",
                path:"team/leader-board",
                logo:<Trophy className='page_sub_navigation_icon' weight="fill"/>,
            },
        ]
    },
    {
        id:3,
        name:"Classes",
        path:"classes",
        Id:"step-3",
        icon:<Chalkboard className='page_navigation_content_icon' weight='fill'/>,
        subNavigation:[
           
        ]
    },
    // {
    //     id:4,
    //     name:"Curriculum",
    //     path:"curriculum/elg",
    //     icon:<BookBookmark className='page_navigation_content_icon' weight='fill'/>,
    //     subNavigation:[
    //         {
    //             id:4.1,
    //             title:"Early Learning Goals",
    //             path:"curriculum/elg",
    //             logo:<Target className='page_sub_navigation_icon' weight="fill"/>,
    //         },
    //         {
    //             id:4.2,
    //             title:"Annual Planner",
    //             path:"curriculum/annual-planner",
    //             logo:<Books className='page_sub_navigation_icon' weight="fill"/>,
    //         },
    //         {
    //             id:4.3,
    //             title:"Daily Planner",
    //             path:"curriculum/planner",
    //             logo:<CalendarPlus className='page_sub_navigation_icon' weight="fill"/>,
    //         },
    //         {
    //             id:4.4,
    //             title:"Holistic Distribution",
    //             path:"curriculum/holistic-distribution",
    //             logo:<ChartPie className='page_sub_navigation_icon' weight="fill"/>,
    //         },
    //     ]
    // },
    {
        id:5,
        name:"Inventory",
        path:"inventory/inventory-overview",
        icon:<Calculator className='page_navigation_content_icon' weight='fill'/>,
        subNavigation:[
            {
                id:5.1,
                title:"Inventory Overview",
                path:"inventory/inventory-overview",
                logo:<Coins className='page_sub_navigation_icon' weight="fill"/>,
            },
            {
                id:5.2,
                title:"Inventory",
                path:"inventory/Inventory",
                logo:<Storefront className='page_sub_navigation_icon' weight="fill"/>,
            },
            {
                id:5.3,
                title:"Add Vendors",
                path:"inventory/add-vendors",
                logo:<UserCircle className='page_sub_navigation_icon' weight="fill"/>,
            },
           
        ]
    },
    {
        id:6,
        name:"Finances",
        path:"finances/fees-overview",
        icon:<Calculator className='page_navigation_content_icon' weight='fill'/>,
        subNavigation:[
            {
                id:5.1,
                title:"Fees Overview",
                path:"finances/fees-overview",
                logo:<Coins className='page_sub_navigation_icon' weight="fill"/>,
            },
            {
                id:5.2,
                title:"Analysis",
                path:"finances/analysis",
                logo:<ChartLineUp className='page_sub_navigation_icon' weight="fill"/>,
            },
            {
                id:5.3,
                title:"Add Transaction",
                path:"finances/add-transaction",
                logo:<PlusCircle className='page_sub_navigation_icon' weight="fill"/>,
            },
           
        ]
    },
    {
        id:7,
        name:"Security",
        path:"security/camera-feeds",
        icon:<ShieldCheckered className='page_navigation_content_icon' weight='fill'/>,
        subNavigation:[
            {
                id:7.1,
                title:"Camera Feeds",
                path:"security/camera-feeds",
                logo:<Desktop className='page_sub_navigation_icon' weight="fill"/>,
            },
            {
                id:7.2,
                title:"Outsiders Profile",
                path:"security/outsiders",
                logo:<UserCircle className='page_sub_navigation_icon' weight="fill"/>,
            },
           
        ]
    },
    // {
    //     id:8,
    //     name:"Marketing",
    //     path:"marketing",
    //     icon:<MegaphoneSimple className='page_navigation_content_icon' weight='fill'/>
    // },
]

export const footer=[
    {
        id:1,
        name:"Leave Management",
        path:"/dashboard/leave-management",
        icon: <TreeEvergreen  className='footer_icon' 
        weight='fill'/>
    },
    {
        id:2,
        name:"My Plan",
        path:"/dashboard/plan",
        icon: <RocketLaunch className='footer_icon' 
        weight='fill'/>
    },
    {
        id:3,
        name:"Settings",
        path:"/dashboard/setting",
        icon: <GearSix className='footer_icon'
        weight='fill'/>
    },
    {
        id:4,
        name:"Account & Payments",
        path:"/dashboard/account-and-payments",
        icon: <Bag className='footer_icon'
        weight='fill'/>
    },
    {
        id:5,
        name:"My Profile",
        path:"/dashboard/profile",
        icon: <UserCircle className='footer_icon'
        weight='fill'/>
    },
    {
        id:7,
        name:"Switch Preschool",
        path:"/preschools",
        icon: <UserSwitch  className='footer_icon'
        weight='fill'/>
    },
    {
        id:6,
        name:"Logout",
        // path:"/dashboard/my-plan",
        icon: <Power className='footer_icon'
        weight='fill'/>
    },
]